import React, { useEffect, useRef } from "react";

export default function ScrollAnchor() {
    const scrollAnchorRef = useRef();

    useEffect(() => {
        if (scrollAnchorRef.current) {
            scrollAnchorRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, []);

    return (
        <div ref={scrollAnchorRef} />
    );
}
